import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Row } from "react-bootstrap";
import MaterialReactTable, {
  type MRT_ColumnDef,
  type MRT_SortingState,
  type MRT_PaginationState,
} from "material-react-table";

import InputText from "components/common/InputText";
import {
  subUsersApiCall,
  userDeleteApiCall
} from "services/userService";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import { buttonColor } from "constants/constants";
import phoneMask from "helpers/phoneMask";

/**
 * Create a custom component which will render today's inspection section in dashboard.
 * @param props
 * @returns Today's Inspection component
 */
export const DataTable = (props: { userId: number }) => {
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [sorting, setSorting] = useState<MRT_SortingState>([
    { id: sortColumn, desc: false },
  ]); // The default sorting data to show status column sort icon
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [inspectionDate, setInspectionDate] = useState("");
  const [status, setStatus] = useState("all");
  const [mutation,setMutation]= useState(true);
  const [outstandingBalance, setOutstandingBalance] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [fromRows, setFromRows] = useState(0);
  const [toRows, setToRows] = useState(0);

  useEffect(() => {
    fetchSubUsers();
  }, [sorting, searchData, pagination.pageIndex, pagination.pageSize,mutation]);
const handleSearch = (value) => {
setSearchData(value);
}
  const fetchSubUsers = async () => {
    const param = {
      sortColumn: 0 in sorting ? sorting[0].id : sortColumn,
      sortDirection:
        0 in sorting
          ? sorting[0].desc === false
            ? "asc"
            : "desc"
          : sortDirection,
      page: pagination.pageIndex + 1,
      ...(searchData ? {search : searchData} : {})
     
    };

    subUsersApiCall(param, props.userId).then((response) => {
      const newData = response.userResult;
      setData(newData);
      setTotalPages(response.totalPages);
      setRowCount(response.totalResults);

     

      const fromRowsVal =
      response.userResult.length > 0
        ? (response.page - 1) * response.limit + 1
        : 0;
    let toRowsVal = fromRowsVal + response.userResult.length - 1;
    toRowsVal = toRowsVal > 0 ? toRowsVal : 0;
    setFromRows(fromRowsVal);
    setToRows(toRowsVal);


    });
  };


 
const handleDelete = (id:number) =>{
  Swal.fire({
    title: "Are You sure?",
    text: "You want to delete this user.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: buttonColor.confirmButtonColor,
    cancelButtonColor: buttonColor.cancelButtonColor,
    color: buttonColor.color,
    confirmButtonText: "Yes, Submit it!",
  }).then((result) => {
    if (result.isConfirmed) {
      userDeleteApiCall(id)
      .then((response) => {
        // setBtnLoading(false);
        toast.success(response.message);
        setMutation(!mutation)
      })
      .catch((error) => {
        //setBtnLoading(false);
      });
    }
  });
}


  /* Column Definition requires for MaterialReactTable */
  type UserInterface = {
   
    full_name: string;
    email: string;
    phone_no: string;
    designation: string;
    id : number;
  };

  // Mentioning table columns belows.
  const tableColumns = useMemo<MRT_ColumnDef<UserInterface>[]>(
    () => [  
      {
        accessorKey: "full_name",
        size: 150, //small column
        muiTableHeadCellProps: () => ({className: 'text-nowrap'}),
        header: "Name",
        Cell: ({ cell, row }) => `${row.original.full_name}`,
      },
      {
        accessorKey: "email",
        muiTableHeadCellProps: () => ({className: 'text-nowrap'}),
        header: "Email",
        Cell: ({ cell, row }) => `${row.original.email}`,

      },
      {
        accessorKey: "phone_no",
        muiTableHeadCellProps: () => ({className: 'text-nowrap'}),
        header: "phone",
        Cell: ({ cell, row }) => { return <span>{phoneMask(row.original.phone_no)}</span>}
      },
      {
        accessorKey: "designation",
        
        muiTableHeadCellProps: () => ({className: 'text-nowrap'}),

        header: "Designation",
        Cell: ({ cell, row }) => `${row.original.designation}`,
      },    
      
      {
        accessorKey: "id",
        header: "Action",
        minSize: 100, //min size enforced during resizing
    maxSize: 400, //max size enforced during resizing
    size: 180, //medium column
        enableSorting: false,
        Cell: ({ cell, row }) => {
          return (
            <>
              <OverlayTrigger overlay={<Tooltip>Delete User</Tooltip>}>
                <span
                  role="button"
                  className="d-inline-block text-danger"
                  onClick={()=>handleDelete(row.original.id)}
                >
                 <i className="fa fa-trash"></i>
                </span>
              </OverlayTrigger>{" "}
             
            </>
          );
        },
      },
    ],
    []
  );

  const today = new Date();
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
  };
  const formattedDate: string = today.toLocaleDateString("en-US", options);
  return (
    <div className="col-xl-12 mb-3">
      <Card.Body className="br-10 p-4 new-table-design">
        <Row className="">
          <Col className="billing-serch-input col-md-12 col-lg-3  col-12 col">
            <InputText
              controlId="search"
              label=""
              placeholder="Search Here"
              touched={false}
              handleBlur={false}
              handleChange={(e)=>{handleSearch(e.target.value)}}
              errorsField={false}
              value={searchData}
            />
          </Col>
         
        </Row>
        <div className="table-responsive ">
          <MaterialReactTable
            muiTableProps={{
              classes: {
                root: "table custom-table border-none-table table-striped custom-tableNew",
              },
            }}
            enableGlobalFilter={false}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            enableHiding={false}
            enableColumnFilters={false}
            enablePagination={false}
            columns={tableColumns}
            data={data}
            onSortingChange={setSorting}
            manualSorting
            state={{ sorting }}
          />
          {totalPages > 0 ? (
            <div className="paggination">
              <p className="showing-text">
                Showing {fromRows}-{toRows} of {rowCount}
              </p>
              <Pagination
                count={totalPages}
                shape="rounded"
                variant="outlined"
                onChange={(event, newPage) => {
                  const pagi = { ...pagination, pageIndex: newPage - 1 };
                  setPagination(pagi);
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </Card.Body>
    </div>
  );
};
